<template>
  <multiple_form
    :forms="forms"
    :edit="props.isEdit"
    :disabled="props.isDetail"
    :editData="props.editData"
    :itemCol="24"
    :disabledDate="disabledDate"
    @submit="handelSubmit"
    :submitBtn="!props.isDetail"
  />
</template>
<script setup>
  import { ref, defineProps, defineEmits, computed } from 'vue'
  import { message } from 'ant-design-vue'
  import { createData, updateData } from '@/api/black_white_list/car_black_white_list'
  import multiple_form from '@/components/multiple_form'
  import { blackWhiteListType } from '@/utils/common'
  import { constantToOptions } from '@/utils/format'
  import dayjs from 'dayjs'

  // 日期禁用
  const disabledDate = (current) => {
    return current && current < dayjs().subtract(1,'days').endOf('day')
  }
  //初始化
  const props = defineProps({
    isEdit: Boolean,
    editData: Object,
    data: Array,
    idField: String,
    isDetail: Boolean,
  })
  const emit = defineEmits(['submit'])
  const formRef = ref()

  //编辑、新增的表单
  const forms = computed(() => [
    {
      id: 'car_list',
      itemWidth: '420px',
      formItem: [
        {
          type: 'input',
          field: 'license_plate',
          label: '车牌号码',
        },
        {
          type: 'select',
          field: 'type_id',
          label: '车型',
          storeOptions: 'carModel',
        },
        {
          type: 'radio',
          field: 'type',
          options: constantToOptions(blackWhiteListType),
          label: '名单类型',
        },
        {
          type: 'dateRange',
          startField: 'start_time',
          endField: 'end_time',
          label: '有效时间',
        },
        {
          type: 'input',
          field: 'reason',
          label: '原因备注',
        },
      ],
    },
  ])

  async function handelSubmit(data) {
    const ajaxFn = props.isEdit ? updateData : createData
    const messageText = props.isEdit ? '编辑' : '创建'
    const id = props.isEdit
      ? { [props.idField]: props.editData[props.idField] }
      : {}
    const res = await ajaxFn({ ...data, ...id })
    if (res.success) {
      message.success(messageText + '成功！')
      emit('submit')
    } else {
      message.warn(messageText + '错误：', res.message)
    }
  }

  function resetForm() {
    formRef.value.resetFields()
  }
</script>
